// API related actions
export const LOAD_PROVIDERS_REQUEST = '@@toyota/LOAD_PROVIDERS_REQUEST';
export const LOAD_PROVIDERS_SUCCESS = '@@toyota/LOAD_PROVIDERS_SUCCESS';
export const LOAD_PROVIDERS_FAILED = '@@toyota/LOAD_PROVIDERS_FAILED';
export const SUBMIT_EDIT_PROVIDER_REQUEST = '@@toyota/SUBMIT_EDIT_PROVIDER_REQUEST';
export const SUBMIT_EDIT_PROVIDER_SUCCESS = '@@toyota/SUBMIT_EDIT_PROVIDER_SUCCESS';
export const SUBMIT_EDIT_PROVIDER_FAILED = '@@toyota/SUBMIT_EDIT_PROVIDER_FAILED';
export const LOAD_PROVIDER_ORDERS_REQUEST = '@@toyota/LOAD_PROVIDER_ORDERS_REQUEST';
export const LOAD_PROVIDER_ORDERS_SUCCESS = '@@toyota/LOAD_PROVIDER_ORDERS_SUCCESS';
export const LOAD_PROVIDER_ORDERS_FAILED = '@@toyota/LOAD_PROVIDER_ORDERS_FAILED';
// complementary actions
export const INITIALIZE_PROVIDER_DATA = '@@toyota/INITIALIZE_PROVIDER_DATA';
export const CHANGE_PROVIDER_TEXT_FILTER = '@@toyota/CHANGE_PROVIDER_TEXT_FILTER';
export const FILTER_PROVIDERS = '@@toyota/FILTER_PROVIDERS';
export const CHANGE_PROVIDERS_LIST_PAGE = '@@toyota/CHANGE_PROVIDERS_LIST_PAGE';
export const CHANGE_PROVIDERS_LIST_PAGE_SIZE = '@@toyota/CHANGE_PROVIDERS_LIST_PAGE_SIZE';
export const CHANGE_PROVIDER_TRANSPORT_TYPE = '@@toyota/CHANGE_PROVIDER_TRANSPORT_TYPE';
export const TOGGLE_ORDER_DETAIL = '@@toyota/TOGGLE_ORDER_DETAIL';
